import * as $ from 'jquery';

export default function init() {
	let select2Element = '#formWrapper\\:application\\:positionApplyingFor';

	if ($(select2Element).length === 0) {
		return;
	}

	const select2 = require('select2');
	select2($);

	const initSelect2 = () => {
		$(select2Element).select2({
			multiple: true
		});
	}

	initSelect2();
	
	document.addEventListener('jsfAjaxEvent', (event) => {
		const detail: any = (event as any).detail;
		if (detail !== undefined) {
			if (detail.fireType === 'always') {
				initSelect2();
			}
		}
	});
}
